import { customAxios } from './customAxios'
export function getListe() {
  const config = {
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }
  const getListeRequest = customAxios.get(
    process.env.REACT_APP_BACKEND_HOST + `/`+process.env.REACT_APP_PATH_NEW_PREFIX+`/getListe?`,
    null,
    config,
  )
  return getListeRequest
}
